import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-provider-container-component',
  templateUrl: './provider-container.component.html',
})
export class ProviderContainerComponent {}
